import type React from "react";
import { FullscreenSpinner, GrantedTextLogo, useMedia, type ViewProps, validToken, XStack, YStack } from "@medbillai/ui";
import { useRouter } from "@medbillai/navigation/router";
import { useAuth } from "../../lib/auth";
import { CasesPanelProvider } from "../../provider/cases-panel/CasesPanelProvider";
import { CasesSlidePanel } from "./components/CasesSlidePanel.web";
import { MobileNavPopover } from "./components/MobileNavPopover.web";
import { WebNavigation } from "./components/WebNavigation.web";
export type HomeLayoutProps = {
  children?: React.ReactNode;
  padded?: boolean;
  fullPage?: boolean;
  backgroundColor?: ViewProps["backgroundColor"];
  hideTabs?: boolean;
  title?: string;
};
export const HomeLayout = ({
  children,
  fullPage = false,
  padded = false,
  backgroundColor = "$surface1",
  hideTabs = false
}: HomeLayoutProps) => {
  const {
    isReady
  } = useAuth();
  const router = useRouter();
  const media = useMedia();
  if (!isReady) {
    return <FullscreenSpinner />;
  }
  return <CasesPanelProvider data-sentry-element="CasesPanelProvider" data-sentry-component="HomeLayout" data-sentry-source-file="layout.web.tsx">
      <XStack f={1} height={validToken("100dvh")} overflow="hidden" backgroundColor={backgroundColor} data-sentry-element="XStack" data-sentry-source-file="layout.web.tsx">
        {media.gtSm ? <WebNavigation /> : null}
        <YStack f={1} overflow="hidden" position="relative" data-sentry-element="YStack" data-sentry-source-file="layout.web.tsx">
          {!media.gtSm && !hideTabs ? <YStack borderBottomWidth={1} borderBottomColor="$strokeSecondary" backgroundColor="$surface1" paddingHorizontal="$4" paddingVertical="$2.5">
              <XStack jc="space-between" ai="center">
                <YStack onPress={() => router.push("/")} cursor="pointer" justifyContent="center" alignItems="center" minHeight={54}>
                  <GrantedTextLogo width={80} height={16} />
                </YStack>
                <MobileNavPopover>
                  <WebNavigation />
                </MobileNavPopover>
              </XStack>
            </YStack> : null}
          <CasesSlidePanel data-sentry-element="CasesSlidePanel" data-sentry-source-file="layout.web.tsx" />
          <YStack {...fullPage && {
          flex: 1
        }} {...padded && {
          maxWidth: 800,
          mx: "auto",
          px: "$2",
          width: "100%"
        }} f={1} overflow="scroll" data-sentry-element="YStack" data-sentry-source-file="layout.web.tsx">
            {children}
          </YStack>
        </YStack>
      </XStack>
    </CasesPanelProvider>;
};